import { render, staticRenderFns } from "./EntityCrud.vue?vue&type=template&id=5db8861c&"
import script from "./EntityCrud.vue?vue&type=script&lang=ts&"
export * from "./EntityCrud.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports